import { Navigate } from "react-router-dom";
import { auth } from "../firebase/firebase";
import { useAuth } from "../contexts/AuthContext";

const LinguistProtectedRoute = ({ children }) => {
  const { linguistUserLoggedIn } = useAuth();

  // During fresh login transitions, Firebase user may be present before
  // AuthContext linguist bootstrap flag flips to true.
  if (linguistUserLoggedIn || auth.currentUser) {
    return children;
  }

  return <Navigate to="/linguist-login" replace />;
};

export default LinguistProtectedRoute;
